/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */


import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminRegexClassifierService {

  constructor(private http: HttpClient) { }

  getRegexTraining(category: string, language: string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/regexclassifier/training/${category}/${language}`
      );
  }

  newRegexTraining(category: string, language: string, training: any[]): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/regexclassifier/training`,
        JSON.stringify({ type: category, language: language, terms: training })
      );
  }

  updateRegexTraining(id: string, category: string, language: string, training: any[]): Observable<any> {
    return this.http
      .put(
        `/api/v1/admin/regexclassifier/training/${id}`,
        JSON.stringify({ type: category, language: language, terms: training })
      );
  }

  deleteRegexTraining(id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/regexclassifier/training/${id}`
      );
  }
}



// WEBPACK FOOTER //
// ./client/app/services/admin/admin-regexclassifier.service.ts